'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useState } from 'react';
import { stringify as stringifyQuery } from 'hub-http/helpers/params';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { Link } from 'react-router-dom';

const PasswordInputForm = ({
  query,
  submitting,
  useDark,
  password,
  onChange
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return /*#__PURE__*/_jsxs("div", {
    className: "password-input",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      htmlFor: "password",
      label: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.smartLogin.passwordPrimary"
        })
      }),
      help: /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        onClick: () => setShowPassword(!showPassword),
        children: showPassword ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.form.hidePassword"
        }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.form.showPassword"
        })
      }),
      children: /*#__PURE__*/_jsx(UITextInput, {
        "data-test-id": "password-input-field",
        autoFocus: true,
        id: "password",
        type: showPassword ? 'text' : 'password',
        className: "login-password m-bottom-3",
        value: password,
        onChange: e => onChange(e.target.value),
        disabled: submitting,
        tabIndex: "2",
        use: useDark === 'true' ? 'on-dark' : 'default'
      })
    }), /*#__PURE__*/_jsx(Link, {
      to: {
        pathname: '/forgot',
        search: `?${stringifyQuery(query)}`
      },
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.form.forgotPassword"
      })
    })]
  });
};

PasswordInputForm.propTypes = {
  query: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  useDark: PropTypes.bool,
  password: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default PasswordInputForm;